//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    slidesNo: {
      type: Number,
      default: 3,
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      sliderOptions: {
        arrows: true,
        slidesToShow: this.slidesNo,
        infinite: true,
        slidesToScroll: 1,
        adaptiveHeight: true,
        centerMode: false,
        dots: false,
        nextArrow:
          '<div class="infinite-next-btn"><img v-lazy-load data-src="/images/natural-infusions-2/arrow-right-infusions2.png"></div>',
        prevArrow:
          '<div class="infinite-prev-btn"><img v-lazy-load data-src="/images/natural-infusions-2/arrow-left-infusions2.png"></div>',
        responsive: [
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 960,
            settings: {
              slidesToShow: 2,
            },
          },
          {
            breakpoint: 576,
            settings: {
              slidesToShow: 3,
            },
          },
        ],
      },
    };
  },
};
